import api from './api';

// SSO authentication — delegates to the QuirkyQode main system (Landing server),
// exactly the same pattern used by the B2B Tool and Creative Studio. There is no
// more local username/password store: every login is verified against QQ.
const authService = {
    login: async (email, password) => {
        const response = await api.post('/api/auth/login', { email, password });
        if (response.data.success) {
            localStorage.setItem('vms_token', response.data.token);
            localStorage.setItem('vms_user', JSON.stringify(response.data.user));
        }
        return response.data;
    },

    // Exchanges a QuirkyQode portal token (?qq_token=...) for a VMS-scoped session.
    // Used when the main portal launches VMS directly ("Launch" button on /my-tools).
    ssoExchange: async (qqToken) => {
        const response = await api.post('/api/auth/sso-exchange', { qq_token: qqToken });
        if (response.data.success) {
            localStorage.setItem('vms_token', response.data.token);
            localStorage.setItem('vms_user', JSON.stringify(response.data.user));
        }
        return response.data;
    },

    logout: () => {
        localStorage.removeItem('vms_token');
        localStorage.removeItem('vms_user');
    },

    getCurrentUser: async () => {
        const response = await api.get('/api/auth/me');
        return response.data;
    },

    getStoredUser: () => {
        const userStr = localStorage.getItem('vms_user');
        return userStr ? JSON.parse(userStr) : null;
    },

    getToken: () => {
        return localStorage.getItem('vms_token');
    },

    isAuthenticated: () => {
        return !!localStorage.getItem('vms_token');
    }
};

export default authService;
